import { render, staticRenderFns } from "./EvaluacionRendimientoProfesionalismoCardComponent.vue?vue&type=template&id=ecfc30c4"
import script from "./EvaluacionRendimientoProfesionalismoCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRendimientoProfesionalismoCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports